import { IEmployeeWorkgroupState } from '@/store/employee-workgroup';
import { IEmployeeWorkgroupGetters } from './getters.types';
import { IEmployeeWorkgroup, EmployeeWorkgroup } from '@/models';

export const getters: IEmployeeWorkgroupGetters = {
  getEmployeeWorkgroups(state: IEmployeeWorkgroupState): IEmployeeWorkgroup[] {
    return state.employeeWorkgroups.map(data => new EmployeeWorkgroup(data));
  },

  getEmployeeWorkgroupById: (state: IEmployeeWorkgroupState) => (
    id: number
  ): IEmployeeWorkgroup | undefined => {
    const data = state.employeeWorkgroups.find(
      employeeWorkgroup => employeeWorkgroup.id === id
    );
    if (!data) {
      return undefined;
    }

    return new EmployeeWorkgroup(data);
  }
};
